import { PlayCircleOutline } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import useBucketMediaByShareId from '../../../hooks/useBucketMediaByShareId'

export default function PlaySlideshow() {
  const { shareId } = useParams<{ shareId: string }>()
  const navigate = useNavigate()
  let { pathname } = useLocation()

  const { items } = useBucketMediaByShareId(shareId)

  const onClick = () => {
    pathname += pathname.endsWith('/') ? '' : '/'
    navigate(`${pathname}slideshow?close=true`)
  }

  return (
    <IconButton
      color="primary"
      aria-label="Play Slideshow"
      onClick={onClick}
      disabled={!items.length}
      id="play-slideshow"
      data-testid="play-slideshow"
    >
      <Tooltip title="Play Slideshow" arrow>
        <PlayCircleOutline />
      </Tooltip>
    </IconButton>
  )
}
